
import * as React from 'react';
import { styled, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { closeIcon, homeIcon, logoutIcon, mainIcon, openIcon, summaryIcon, recordDetailIcon, latestPhotoIcon, userIcon, fehdLogo } from '../assets/imgs';
import { Avatar, Menu, MenuItem } from '@mui/material';
import { NavigationContainer, NavigationSideContainer } from '../assets/style';
import { useNavigate } from 'react-router-dom';
import {
    mapPageName,
    recordDetailPageName,
    latestPhotoPageName,
    summaryPageName,
    accountPageName,
} from './PageName';
import { useState } from 'react';
import useLogOut from './LogoutFunction';
import TranslateIcon from '@mui/icons-material/Translate';
import { useTranslation } from 'react-i18next';
import { Person } from '@mui/icons-material';

const drawerWidth = 260;

const openedMixin = (theme: Theme): CSSObject => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

// export default function SideBar() {
const MainContent = React.forwardRef<HTMLDivElement, { style?: React.CSSProperties; children: React.ReactNode; type: String }>((
    { style, children, type }, ref) => {
    const [open, setOpen] = React.useState(false);
    const [select, setSelect] = React.useState(type);
    const navigate = useNavigate();
    const { logoutUser } = useLogOut();
    const handleDrawer = () => {
        setOpen(!open);
    };
    const [page, setPage] = useState(localStorage.getItem('role') === 'Admin' ? [
        mapPageName,
        latestPhotoPageName,
        recordDetailPageName,
        summaryPageName,
        accountPageName,
    ]: [
        mapPageName,
        latestPhotoPageName,
        recordDetailPageName,
        summaryPageName,
    ]);

    const handleSideButtonClick = (text: any) => {
        setSelect(text);
        if (text === mapPageName) {
            navigate(`/map`);
        } else if (text === recordDetailPageName) {
            navigate(`/recordDetail`);
        } else if (text === latestPhotoPageName) {
            navigate(`/recordDetail/latest`);
        } else if (text === summaryPageName) {
            navigate(`/summary`);
        } else if (text === accountPageName) {
            navigate(`/account`);
        }
        else navigate(`/`);
    };

    const { t, i18n } = useTranslation();
    const TranslateIconClick = () => {
        i18n.changeLanguage(i18n.language === "en" ? "zh" : "en");
        localStorage.setItem("i18n", i18n.language);
        //console.log(i18n.language);
    }

    const username = localStorage.user.split("@")[0];

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const changePassword = function () {
        // alert("Coming soon.")
        navigate('/change-password')
        handleClose()
    }

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <Drawer variant="permanent" open={open} PaperProps={{
                sx: {
                    backgroundColor: "#456296",
                    color: "white",
                    // minWidth: open ? "280px" : "80px"
                },
            }}>
                <div style={{ textAlign: "right" }}>
                    <IconButton onClick={handleDrawer}>
                        {!open ? <img src={openIcon} alt='Open Menu' /> : <img src={closeIcon} alt='Close Menu' />}
                    </IconButton>
                </div>
                {/* <DrawerHeader sx={{ minHeight: 100 }}> */}
                {/* <DrawerHeader sx={{ display: 'grid', gridTemplateRows: 'auto 1fr', minHeight: 200 }}> */}
                {/* height: open ? 200 : 50 */}
                {/* <div style={{ display: 'flex' }}> */}

                {/* <div style={{ paddingLeft: '12px' }}>
                        {open && (
                            <Typography
                                sx={{
                                    // fontFamily: 'Otomanopee One',
                                    fontSize: 28,
                                    fontWeight: 400,
                                    // minHeight: 400
                                    // fontWeight: 'bold',
                                }}
                            >
                                {t("360 Degrees Camera System")} <br />{t("for Coastal")}
                            </Typography>
                        )}
                    </div> */}

                {/* </div> */}
                {/* </DrawerHeader> */}
                {/* &nbsp; */}
                {/* <Divider /> */}

                <List sx={{ maxHeight: 'calc(100vh - 100px)', minWidth: "260px" }}>
                    { page.map((text, index) => (
                        <ListItem key={text} disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: select === text ? "#8BB0DB" : "#325594",
                                    borderRadius: select === text ? '0 30px 30px 0px' : "",
                                    width: select === text ? '100%' : "100%",
                                }}
                                onClick={() => handleSideButtonClick(text)}
                            >

                                <ListItemIcon
                                    sx={{
                                        minWidth: 20,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {text === mapPageName && <img src={mainIcon} alt='Map' />}
                                    {text === latestPhotoPageName && <img src={latestPhotoIcon} alt='Latest Record'/>}
                                    {text === recordDetailPageName && <img src={recordDetailIcon} alt='Record Detail' />}
                                    {text === summaryPageName && <img src={summaryIcon} alt='Summary' />}
                                    {text === accountPageName &&  localStorage.getItem('role') === 'Admin' && <img src={userIcon} alt='User' />}
                                </ListItemIcon>
                                <ListItemText primary={t(text)} sx={{ opacity: open ? 1 : 0 }} />
                                {select === text && open && <Avatar
                                    sx={{
                                        px: 1,
                                        mr: 0,
                                        justifyContent: 'center',
                                        width: 48, // Set the width of the Avatar
                                        height: 32, // Set the height of the Avatar
                                    }}
                                    src={logoutIcon} // Replace with your image URLs
                                    alt={text}
                                />}
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
                <Box sx={{ height: "400px" }}></Box>
                <Divider sx={{ backgroundColor: "white", width: "80%" }} />
                <Box sx={{ height: "10px" }}></Box>
                <List>
                    {[t('Logout')].map((text, index) => (
                        <ListItem key={text} disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: "#052A70",
                                    borderRadius: '0 25px 25px 0px', // Rectangle shape
                                    width: '92%',
                                    overflow: 'hidden', // Ensure the half circle is visible
                                }}
                                onClick={() => logoutUser()}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 3 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <img src={logoutIcon} alt="" />
                                </ListItemIcon>
                                <ListItemText primary={text} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Drawer>

            <Box component="main" sx={{ flexGrow: 1, width: '90%', height: '100%' }}>


                <NavigationContainer>
                    <Box sx={{ display: 'flex'}}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                            <img onClick={()=>navigate('/recordDetail/latest')} width={50} height={50} src={fehdLogo} alt='logo' />
                        </Box>
                        <Box sx={{ bgcolor: '#012966', flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <NavigationSideContainer display="flex" sx={{ margin: "16px" }}>
                                    <IconButton sx={{
                                        width: 35,
                                        height: 35,
                                        marginLeft: "5px",
                                    }} onClick={() => { navigate('/recordDetail/latest'); }}>
                                        <img src={homeIcon} alt='Home' />
                                    </IconButton>
                                    <IconButton sx={{
                                        width: 35,
                                        height: 35,
                                        marginLeft: "5px",
                                        color: "#7e8080"
                                    }} onClick={() => TranslateIconClick()}>
                                        <TranslateIcon />
                                    </IconButton>
                                    <IconButton sx={{
                                        width: 35,
                                        height: 35,
                                        marginLeft: "5px",
                                        color: "#7e8080"
                                    }} onClick={handleClick}>
                                        <Person />
                                    </IconButton>
                                    <Box
                                        sx={{ display: 'flex', flexDirection: 'column', cursor: 'pointer' }}
                                        aria-controls="simple-menu"
                                        aria-haspopup="true"
                                    >
                                        <span style={{ marginLeft: "12px", color: "grey" }}>{t("Hello, ")}</span>
                                        <span style={{ marginLeft: "12px", color: "grey" }}>{username}</span>
                                    </Box>
                                    <Menu
                                        id="menu"
                                        anchorEl={anchorEl}
                                        keepMounted
                                        open={Boolean(anchorEl)}
                                        onClose={handleClose}
                                    >
                                        <MenuItem onClick={changePassword}>Change Password</MenuItem>
                                    </Menu>
                                </NavigationSideContainer>
                            </Box>
                        </Box>
                    </Box>
                </NavigationContainer>
                {children}
            </Box>
        </Box >
    )
});
export default MainContent;